module.exports = __webpack_public_path__ + "img/Partner_03.c25f75fd.png";